import React from 'react'
import "./ImageAdd.css"
import CloseIcon from '@mui/icons-material/Close';
import { BiSolidImageAdd } from "react-icons/bi";

export default function ImageAdd({ productImageHandler, productData, removeImageHandler, imageIndex }) {
    // console.log(("productData-------->", productData.image))
    return (
        <div className=' w-100 d-flex'>

            {/* <hr classNameName="sidebar-divider" /> */}



            {productData.image.length > 0 ? <div className='d-flex   p-1' style={{ gap: '30px', flexWrap: "wrap" }}>

                {productData.image.map((img, index) => (
                    <div key={index} className='p-1 border rounded' style={{ boxSizing: "border-box", justifySelf: "flex-start", maxWidth: "120px", maxHeight: "120px", position: "relative" }}>

                        <CloseIcon style={{ position: "absolute", top: "5px", right: "5px", cursor: "pointer", fontSize: '12px' }} onClick={() => removeImageHandler(index, imageIndex)} />

                        <div key={index} className='w-100 h-100' >

                            <img src={img} className='w-100' style={{ objectFit: "contain", height: "100%" }} />

                        </div>
                    </div>

                ))
                }

            </div> : null}


            <div className="file-input-container " >
                <input type="file" id="image" accept="image/*" name="image" multiple className='input_file' onChange={(e) => productImageHandler(e, imageIndex)}
                />
                {/* <label for="image" className="custom-file-input-button">
                    Upload New
                </label> */}
                <label for="image" className='d-flex flex-column align-items-center justify-content-center border rounded mt-1'>
                    <div>
                        <BiSolidImageAdd for="image" size={95} />

                    </div>
                    <div>
                        <span style={{ fontSize: "12px" }}>add images</span>

                    </div>
                </label>

            </div>

        </div>
    )
}
